<template>
  <div v-if="type === 'password'" class="password-input-wrapper">
    <input
      ref="input"
      :value="modelValue"
      :type="passwordVisible ? 'text' : 'password'"
      class="form-control password-input"
      :placeholder="placeholder"
      :disabled="disabled"
      @input="handleInput"
      @focus="handleFocus"
    />
    <button type="button" class="password-toggle" @click="passwordVisible = !passwordVisible" tabindex="-1">
      <EyeOffIcon v-if="passwordVisible" :size="18" />
      <EyeIcon v-else :size="18" />
    </button>
  </div>
  <input
    v-else
    ref="input"
    :value="modelValue"
    :type="type"
    class="form-control"
    :placeholder="placeholder"
    :disabled="disabled"
    @input="handleInput"
    @focus="handleFocus"
  />
</template>

<script>
import EyeIcon from 'vue-material-design-icons/Eye.vue';
import EyeOffIcon from 'vue-material-design-icons/EyeOff.vue';

export default {
  name: 'TextInput',
  components: {
    EyeIcon,
    EyeOffIcon
  },
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      passwordVisible: false
    };
  },
  methods: {
    handleFocus(event) {
      // Auto-select all text for easy overwriting
      event.target.select();
    },
    handleInput(event) {
      this.$emit('update:modelValue', event.target.value);
    }
  },
  emits: ['update:modelValue']
}
</script>

<style scoped>
.password-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.password-input {
  padding-right: 36px;
  width: 100%;
}

.password-toggle {
  position: absolute;
  right: 8px;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #9ca3af;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.password-toggle:hover {
  color: #6b7280;
}
</style>
